/* KÔBO — Labo d'extraction espresso (simulation interactive) */
(function () {
  var root = document.querySelector('[data-k-lab]'); if (!root) return;
  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var ins = {}, outs = {};
  $$('[data-in]').forEach(function (i) { ins[i.dataset.in] = i; });
  $$('[data-out]').forEach(function (o) { outs[o.dataset.out] = o; });
  var svg = $('.k-lab-svg'), stream = $('.kl-stream', svg), liq = $('.kl-liq', svg), crema = $('.kl-crema', svg), drops = $('.kl-drops', svg);
  var gramsT = $('.kl-grams', svg), timeT = $('.kl-time', svg), needle = $('.kl-needle', svg), stops = $$('[data-stop]', svg);
  var CUP_TOP = 236, CUP_BOT = 326, CUP_H = CUP_BOT - CUP_TOP, MAXG = 60;
  var running = false, raf = 0, t0 = 0, SPEED = 3.2;

  function params() { return { g: +ins.grind.value, d: +ins.dose.value, T: +ins.temp.value, t: +ins.time.value }; }

  function model(p) {
    var flow = (0.85 + 0.24 * p.g) * Math.pow(18 / p.d, 0.5);
    var Y = flow * p.t, ratio = Y / p.d;
    /* Le ratio est un RÉSULTAT de la mouture, pas un levier indépendant : le faire
       entrer dans le calcul revenait à compter la mouture deux fois, avec des signes
       opposés. Les deux s'annulaient et l'extraction restait bloquée à ~20,5 % quelle
       que soit la mouture. L'extraction se calcule donc sur les leviers réellement
       indépendants : surface (mouture), température, temps de contact et dose. */
    var E = clamp(20.5 + 0.55 * (p.T - 93) + 1.05 * (5 - p.g) + 0.075 * (p.t - 28) + 0.25 * (18 - p.d), 12, 28);
    var acid = clamp(9 - (E - 15) * 1.15, 0, 10), bitter = clamp((E - 19) * 1.6 + (p.T - 93) * 0.15, 0, 10),
      sweet = clamp(10 - Math.abs(E - 20) * 1.7, 0, 10), body = clamp(2 + (p.d - 14) * 0.55 + (2.6 - ratio) * 2.2, 0, 10);
    var v;
    if (E < 17.5) v = { t: 'Sous-extrait', c: 'under', p: 'Acide, court en bouche, peu de douceur. Mouds plus fin, allonge le temps ou monte un peu la température.' };
    else if (E > 22.5) v = { t: 'Sur-extrait', c: 'over', p: 'Amer, sec, astringent. Mouds plus gros, raccourcis le temps ou baisse un peu la température.' };
    else v = { t: 'Équilibré', c: 'ok', p: 'Sucrosité, acidité et corps sont en équilibre. Note cette recette, c’est la bonne.' };
    if (p.t < 20) v.p += ' Attention : moins de 20 s, le café risque d’être sous-développé.';
    if (p.t > 38) v.p += ' Au-delà de 38 s, le débit est trop lent : mouds plus gros.';
    return { flow: flow, Y: Y, ratio: ratio, E: E, acid: acid, bitter: bitter, sweet: sweet, body: body, v: v };
  }

  function fmt() {
    var p = params(), m = model(p);
    outs.grind.textContent = (+p.g).toFixed(1).replace('.0', ''); outs.dose.textContent = p.d + ' g'; outs.temp.textContent = p.T + ' °C'; outs.time.textContent = p.t + ' s';
    $('[data-stat=yield]').textContent = m.Y.toFixed(1) + ' g'; $('[data-stat=ratio]').textContent = '1 : ' + m.ratio.toFixed(2); $('[data-stat=ext]').textContent = m.E.toFixed(1) + ' %';
    return { p: p, m: m };
  }

  function radar(m, k) {
    k = k == null ? 1 : k;
    var pts = [[0, -m.acid * 9], [m.sweet * 9, 0], [0, m.body * 9], [-m.bitter * 9, 0]].map(function (a) { return [a[0] * k, a[1] * k]; });
    $('.k-radar .shape').setAttribute('points', pts.map(function (a) { return a[0].toFixed(1) + ',' + a[1].toFixed(1); }).join(' '));
    $$('.k-radar .dots circle').forEach(function (c, i) { c.setAttribute('cx', pts[i][0]); c.setAttribute('cy', pts[i][1]); });
  }
  function sweet(m) { var pct = clamp((m.E - 14) / 12, 0, 1) * 100; $('[data-sweet]').style.left = pct + '%'; }
  function verdict(m) { var v = $('[data-verdict]'); v.className = 'k-verdict ' + m.v.c; v.innerHTML = '<b>' + m.v.t + '</b><p>' + m.v.p + '</p>'; }

  function colorFor(E) {
    /* jaune/vert clair (sous) -> ambre -> presque noir (sur) */
    var t = clamp((E - 14) / 12, 0, 1), a = [214, 170, 70], b = [110, 62, 24], c = [26, 12, 6];
    var mix = function (x, y, k) { return [x[0] + (y[0] - x[0]) * k, x[1] + (y[1] - x[1]) * k, x[2] + (y[2] - x[2]) * k]; };
    var col = t < 0.5 ? mix(a, b, t / 0.5) : mix(b, c, (t - 0.5) / 0.5);
    return 'rgb(' + col.map(Math.round).join(',') + ')';
  }
  function paintLiquid(E) {
    var base = colorFor(E); stops[1].setAttribute('stop-color', base); stops[2].setAttribute('stop-color', colorFor(E + 4)); stops[0].setAttribute('stop-color', '#e0a35c');
  }

  function setLevel(g, m) {
    var h = clamp(g / MAXG, 0, 1) * CUP_H, y = CUP_BOT + 6 - h;
    liq.setAttribute('y', y); liq.setAttribute('height', h + 8);
    var ch = Math.min(9, h * 0.35); crema.setAttribute('y', y - 1); crema.setAttribute('height', ch);
    gramsT.textContent = g.toFixed(1) + ' g';
  }

  function reset() {
    cancelAnimationFrame(raf); running = false; drops.innerHTML = '';
    stream.setAttribute('height', 0); needle.style.transform = 'rotate(-120deg)'; timeT.textContent = '00:00';
    var s = fmt(); paintLiquid(s.m.E); setLevel(0, s.m); radar(s.m, 0.25); sweet(s.m);
    $('[data-verdict]').className = 'k-verdict'; $('[data-verdict]').innerHTML = '<b>Prêt à extraire</b><p>Règle la mouture, la dose, la température et le temps, puis lance l’extraction.</p>';
    $('[data-lab-run] span').textContent = 'Lancer l’extraction'; root.classList.remove('is-running');
  }

  function drop(x, y, vy) { var c = document.createElementNS('http://www.w3.org/2000/svg', 'circle'); c.setAttribute('r', 1.6 + Math.random() * 1.4); c.setAttribute('cx', x + (Math.random() - 0.5) * 3); c.setAttribute('cy', y); c.setAttribute('fill', '#b8722e'); c._vy = vy; drops.appendChild(c); }

  function run() {
    var s = fmt(), p = s.p, m = s.m; if (running) return;
    running = true; root.classList.add('is-running'); $('[data-lab-run] span').textContent = 'Extraction…'; paintLiquid(m.E); radar(m, 0.25); sweet(m);
    var total = p.t / SPEED, start = performance.now(), lastDrop = 0;
    var loop = function (now) {
      var e = (now - start) / 1000, k = clamp(e / total, 0, 1);
      var pre = clamp(e / 0.9, 0, 1);   /* pré-infusion : filet qui s'installe */
      var g = m.Y * Math.pow(k, 0.92);  /* débit quasi linéaire, léger ralentissement */
      timeT.textContent = '00:' + String(Math.round(k * p.t)).padStart(2, '0');
      needle.style.transform = 'rotate(' + (-120 + 210 * Math.sin(Math.min(1, e / 1.2) * Math.PI / 2) * (k < 0.92 ? 1 : (1 - k) / 0.08)) + 'deg)';
      var surf = CUP_BOT + 6 - clamp(g / MAXG, 0, 1) * CUP_H, sh = Math.max(0, surf - 134);
      stream.setAttribute('height', k < 1 ? sh * Math.min(1, pre * 1.4) : 0);
      stream.setAttribute('width', k < 1 ? 2 + Math.min(3, m.flow * 0.9) : 0); stream.setAttribute('x', 240 - (2 + Math.min(3, m.flow * 0.9)) / 2);
      if (k < 1 && now - lastDrop > 90 / Math.max(0.6, m.flow)) { lastDrop = now; drop(240, 134, 0); }
      $$('circle', drops).forEach(function (c) { c._vy += 0.5; var y = +c.getAttribute('cy') + c._vy; c.setAttribute('cy', y); if (y > CUP_BOT - 6) c.remove(); });
      setLevel(g, m); radar(m, 0.25 + 0.75 * k);
      if (k < 1) raf = requestAnimationFrame(loop);
      else { running = false; root.classList.remove('is-running'); stream.setAttribute('height', 0); needle.style.transform = 'rotate(-120deg)'; verdict(m); setLevel(m.Y, m); $('[data-lab-run] span').textContent = 'Relancer'; }
    };
    raf = requestAnimationFrame(loop);
  }

  Object.keys(ins).forEach(function (k) { ins[k].addEventListener('input', function () { if (running) return; var s = fmt(); paintLiquid(s.m.E); radar(s.m, 1); sweet(s.m); }); });
  $('[data-lab-run]').addEventListener('click', function () { if (!running) { setLevel(0, {}); run(); } });
  $('[data-lab-reset]').addEventListener('click', reset);
  reset(); radar(model(params()), 1);
})();
